var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.27397C12.4187 7.27397 16 5.64465 16 3.63698C16 1.62931 12.4187 0 8 0C3.58125 0 0 1.62931 0 3.63698C0 5.64465 3.58125 7.27397 8 7.27397ZM8 13.0891C4.94688 13.0891 2.24688 12.288 0.54375 11.0507C0.196875 11.4597 0 11.8994 0 12.363C0 14.3707 3.58125 16 8 16C12.4187 16 16 14.3707 16 12.363C16 11.8994 15.8031 11.4597 15.4563 11.0541C13.7531 12.288 11.0531 13.0891 8 13.0891ZM8 8.72603C4.94688 8.72603 2.24688 7.92501 0.54375 6.68769C0.196875 7.09672 0 7.53643 0 8C0 10.0077 3.58125 11.637 8 11.637C12.4187 11.637 16 10.0077 16 8C16 7.53643 15.8031 7.09672 15.4563 6.69109C13.7531 7.92501 11.0531 8.72603 8 8.72603Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommission);
export default __webpack_public_path__ + "static/media/commission.b32f015f.svg";
export { ForwardRef as ReactComponent };